import { FunctionComponent } from 'react';
import { styled } from 'styled-components';

const StyledSectionDivider = styled.div<{
	$size: string;
	$fullWidth: boolean;
}>`
	width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
	padding: ${({ $size }) => ($size === 'sm' ? '10px 0' : '20px 0')};
`;

const DividerLine = styled.div<{ $color: string }>`
	width: auto;
	border-bottom: 1px solid
		${({ $color, theme }) => theme.colors[$color] || $color};
	border-bottom: 1px solid
		${({ $color, theme }) => theme.colors[$color] || $color};
`;

const SectionDivider: FunctionComponent<{
	size?: 'sm' | 'md';
	lineColor?: string;
	fullWidth?: boolean;
}> = ({ size = 'md', lineColor = 'borderDefault', fullWidth = false }) => (
	<StyledSectionDivider $size={size} $fullWidth={fullWidth}>
		<DividerLine $color={lineColor} />
	</StyledSectionDivider>
);

export default SectionDivider;
